const mediaItems = [
  {
    title: '2026夏季档新剧前瞻',
    desc: '盘点今夏最值得期待的十部重磅新剧，从悬疑到科幻，从古装到都市，总有一部适合你。',
    duration: '12:35',
    img: 'https://readdy.ai/api/search-image?query=Summer%20TV%20drama%20preview%20showcase%20with%20multiple%20drama%20posters%20collage%2C%20warm%20vibrant%20colors%2C%20entertainment%20news%20style%2C%20professional%20video%20thumbnail%20design%2C%20cinematic%20composition%2C%20engaging%20visual%20layout&width=1000&height=562&seq=media-01&orientation=landscape',
  },
  {
    title: '《暗夜追踪》幕后花絮特辑',
    desc: '独家探班花絮，主演畅谈角色塑造与拍摄趣事。精彩幕后，不容错过。',
    duration: '08:22',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%20set%20with%20cameras%20and%20crew%2C%20warm%20set%20lighting%2C%20director%20and%20actors%20interacting%2C%20movie%20making%20atmosphere%2C%20professional%20cinema%20production%20visual&width=1000&height=562&seq=media-02&orientation=landscape',
  },
  {
    title: '人人影视平台功能使用指南',
    desc: '手把手教你使用播放器高级功能：画质切换、倍速播放、字幕设置、投屏操作等。',
    duration: '05:18',
    img: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20tutorial%20visual%2C%20clean%20UI%20design%20with%20video%20player%2C%20warm%20accent%20colors%2C%20user-friendly%20tech%20education%20style%2C%20minimalist%20digital%20guide%20composition&width=1000&height=562&seq=media-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section
      id="media"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100 scroll-mt-16"
    >
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">
          影视资讯
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.title}
              className="group rounded-lg overflow-hidden bg-background-50 cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 text-xs font-medium bg-black/70 text-background-50 rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}